import { useQuery } from "@tanstack/react-query";
import {ScaleMenu} from "@/shared/api/model";
import { useGetMenus } from "@/shared/api/client/menus";

interface UseMenuType {
    menuLoading: boolean;
    menuError: boolean;
    menus: ScaleMenu[];
}

export const useMenu = (): UseMenuType => {
    const { isLoading, isError, data } = useGetMenus();

    return {
        menuLoading: isLoading,
        menuError: isError,
        menus: data ?? [],
    };
};